import { Highlight20Filled } from "@fluentui/react-icons";
import { MenuButton, useRichTextEditorContext } from "mui-tiptap";
import { useTranslation } from "react-i18next";

export default function MenuButtonHighlight() {
  const editor = useRichTextEditorContext();
  const { t } = useTranslation();

  const IconWrapper = ({ className }: { className: string }) => (
    <Highlight20Filled className={className} />
  );

  return (
    <MenuButton
      IconComponent={IconWrapper}
      onClick={() => editor?.chain().focus().toggleHighlightMark().run()}
      tooltipLabel={t("highlight")}
    />
  );
}
